import React, { ReactNode } from "react";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "@app/component/DashCard/CardTitle.module.scss";
import TextWithInfo from "@app/component/typography/TextWithInfo";

export interface CardTitleProps {
  info?: ReactNode;
  title: string;
  titleFaIcon?: IconProp;
  titleIcon?: ReactNode;
}

const CardTitle: React.FC<CardTitleProps> = ({ info, title, titleFaIcon, titleIcon }) => {
  return (
    <section className={styles.container}>
      {titleIcon}
      {titleFaIcon && <FontAwesomeIcon icon={titleFaIcon} />}
      {(titleIcon || titleFaIcon) && title && " "}
      <TextWithInfo info={info} placement="top">
        {title}
      </TextWithInfo>
    </section>
  );
};

export default CardTitle;
